export const WEBAUTHN_ERROR_NO_CREDENTIAL_OR_CANCELLED =
  "no_credential_or_cancelled";
export const WEBAUTHN_ERROR_UNSUPPORTED = "unsupported";
export const WEBAUTHN_ERROR_ALREADY_REGISTERED = "already_registered";
export const WEBAUTHN_ERROR_UNKNOWN = "unknown";

export const WEBAUTHN_ERROR_MESSAGES = {
  [WEBAUTHN_ERROR_NO_CREDENTIAL_OR_CANCELLED]:
    "No passkey found on this device, or sign-in was cancelled. Try a different sign-in method below",
  [WEBAUTHN_ERROR_UNSUPPORTED]: "This device doesn't support passkeys",
  [WEBAUTHN_ERROR_ALREADY_REGISTERED]:
    "This passkey is already registered to your account",
  [WEBAUTHN_ERROR_UNKNOWN]: "Something went wrong. Please try again",
} as const;
